import React from "react";
import LandingPageChartContainer from "./components/LandingPageChart/LandingPageChartContainer";
import "./PublicChart.scss";

type Props = {
  selectedOddsType: string;
  data: Record<string, any>;
};

const PublicChart: React.FC<Props> = ({ data, selectedOddsType }) => {
  return (
    <div className="charts-container">
      {data.landingPageGraphs &&
        data.landingPageGraphs.map((data, index) => (
          <LandingPageChartContainer
            key={index}
            data={data}
            selectedOddsType={selectedOddsType}
          />
        ))}
    </div>
  );
};

export default PublicChart;
